import { useMemo, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { fetchEmployees } from "services/dropdown";
import zoneLocalStorageId from "utils/zone";

const MarketingPersonDropdown = ({
  errors,
  control,
  required,
  defaultValue,
  setValue,
  onMembershipChange,
  employeeType = "MARKETING",
}) => {
  const login = useSelector((state) => state.jwtAuthreducer);

  const {
    data: memberships,
    isLoading,
    isError,
  } = useQuery(
    ["fetch-employees", zoneLocalStorageId(), employeeType],
    () => fetchEmployees(zoneLocalStorageId(), employeeType),
    {
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  const options = useMemo(() => {
    return (
      memberships?.data?.data?.map((item) => ({
        value: item?.employee_code_id,
        label: item?.employee_name,
      })) || []
    );
  }, [memberships]);

  useEffect(() => {
    if (options.length > 0 && defaultValue && setValue) {
      const selectedOption = options.find((opt) => opt.value === defaultValue);
      if (selectedOption) {
        setValue("marketing_person_id", selectedOption.value);
      }
    }
  }, [options, defaultValue, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading memberships</div>;

  return (
    <Controller
      name="marketing_person_id"
      control={control}
      defaultValue={defaultValue || ""}
      rules={{ required: required ? "Marketing Person is required" : false }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Marketing Person"
          value={options.find((option) => option.value === field.value) || null}
          onChange={(selectedOption) => {
            field.onChange(selectedOption?.value || "");

            if (selectedOption && setValue) {
              setValue("marketing_person_id", selectedOption.value);
            } else if (setValue) {
              setValue("marketing_person_id", "");
            }

            if (onMembershipChange) {
              onMembershipChange(selectedOption);
            }
          }}
        />
      )}
    />
  );
};

export default MarketingPersonDropdown;
